import React, { useState } from 'react';
import {
  Box,
  Text,
  SimpleGrid,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  VStack,
  Link,
  Button,
} from '@chakra-ui/react';

import Navbar from '../Components/Navbar';
import { Link as RouterLink } from 'react-router-dom';

import jpfQuestionImg from '../assets/jpfQuestionImg.png';
import fullTimeImg from '../assets/fullTimejobImg.png';
import needResourcesImg from '../assets/needResourcesImg.png';
import studyAbroadImg from '../assets/studyAbroadImg.png';

function Resources() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTab, setSelectedTab] = useState(null);

  const resourceTabs = [
    {
      Title: 'I have a Jump Finance Related Question',
      Image: jpfQuestionImg,
      children: (
        <>
          <Text>Jump Finance Bank Account Numbers:</Text>
          <br />
          <Text>Bank: Ecobank</Text>
          <Text>Account Name: Jump Finance</Text>
          <Text>Account #: 6240025074</Text>
          <br />
          <Text>Bank: GTBank</Text>
          <Text>Account Name: Jump Finance</Text>
          <Text>Account #: 201-135803-110</Text>
          <br />
          <Text>
            Read our FAQs:{' '}
            <Link
              href="https://apply.jump-finance.com/faq"
              isExternal
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
            >
              https://apply.jump-finance.com/faq
            </Link>
          </Text>
          <br />
          <Text>
            Send us a WhatsApp:{' '}
            <Link
              href="https://wa.me/17372026552"
              isExternal
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
            >
              +1 737 202-6552
            </Link>
          </Text>
        </>
      ),
    },
    {
      Title: 'I want to get a full time job in The Gambia',
      Image: fullTimeImg,
      children: (
        <>
          <Link
            as={RouterLink}
            to="/resume-resources"
            textColor="teal.500"
            textDecoration="underline"
            fontWeight="medium"
            _hover={{ textColor: 'teal.600' }}
          >
            Make a professional resume
          </Link>
          <Text>
            Gam Jobs:{' '}
            <Link
              href="https://gamjobs.com/"
              isExternal
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
            >
              https://gamjobs.com/
            </Link>
          </Text>
          <Text>
            Youth Empowerment Project:{' '}
            <Link
              href="https://yep.gm/opportunities?category=job-offer"
              isExternal
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
            >
              YEP | Opportunities
            </Link>
          </Text>
        </>
      ),
    },
    {
      Title: 'I want to make some money part time online!',
      Image: fullTimeImg,
      children: (
        <>
          <Text>Set up an account at Preply to tutor students online:</Text>
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://preply.com"
              isExternal
            >
              Teach online: Become an online tutor at Preply
            </Link>
          </Text>
          <br />
          <Text>
            Set up an account at Upwork to do freelance projects (data, design etc):{' '}
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://www.upwork.com/signup"
              isExternal
            >
              www.upwork.com/signup
            </Link>
          </Text>
          <br />
          <Text>Set up an account at Fiverr to tutor students online:</Text>
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://fiverr.com"
              isExternal
            >
              Fiverr - Freelance Services Marketplace
            </Link>
          </Text>
        </>
      ),
    },
    {
      Title: 'I have a small business and I need resources:',
      Image: needResourcesImg,
      children: (
        <>
          <Text>I have a business where I need an investment to grow:</Text>
          <Button
            as={RouterLink}
            to="/small_business_app"
            bg="#00C49A"
            size="md"
            borderRadius="md"
            _hover={{ bg: '#00B388' }}
          >
            Click here to apply for a loan
          </Button>
        </>
      ),
    },
    {
      Title: 'I am interested in studying/working abroad:',
      Image: studyAbroadImg,
      children: (
        <>
          <Text>
            Scholarships | ESSA:{' '}
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://africanscholarshiphub.org"
              isExternal
            >
              africanscholarshiphub.org
            </Link>
          </Text>
          <br />
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://www.opportunitiesforafricans.com/category/scholarships/"
              isExternal
            >
              https://www.opportunitiesforafricans.com/category/scholarships/
            </Link>
          </Text>
        </>
      ),
    },
    {
      Title: 'I Need Academic Resources:',
      Image: studyAbroadImg,
      children: (
        <>
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://www.khanacademy.org"
              isExternal
            >
              Khan Academy
            </Link>
          </Text>
          <br />
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://www.codecademy.com"
              isExternal
            >
              Codecademy
            </Link>
          </Text>
          <br />
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://scholar.google.com"
              isExternal
            >
              Google Scholar
            </Link>
          </Text>
          <br />
          <Text>
            <Link
              textColor="blue"
              textDecoration="underline"
              fontWeight="bold"
              href="https://grow.google/certificates"
              isExternal
            >
              Google Certifications
            </Link>
          </Text>
          <br />
          <Text>Excel Videos</Text>
        </>
      ),
    },
  ];

  return (
    <div>
      {/* Header */}
      <Box
        bg="#00D29D"
        w="100%"
        h="8vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Text fontSize="16px" fontWeight="semibold" mt="1vh">
          Resource Hub
        </Text>
      </Box>

      {/* Page Title */}
      <Box p={[2, 4]} mx="auto" maxW="1200px">
        <Text fontWeight="semibold" fontSize="25px" textAlign="center">
          Resources
        </Text>
      </Box>

      {/* Grid of Squares */}
      <SimpleGrid columns={[2, null, 3]} spacing={6} px={[4, 8]} py={4}>
        {resourceTabs.map((tab, idx) => (
          <Box
            key={idx}
            bg="#e6fff9"
            boxShadow="md"
            borderRadius="md"
            p={4}
            w="100%"
            aspectRatio={1}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            _hover={{ boxShadow: 'lg', cursor: 'pointer' }}
            onClick={() => {
              setSelectedTab(tab);
              onOpen();
            }}
          >
            <Image src={tab.Image} alt={tab.Title} boxSize="60px" mb={3} />
            <Text fontWeight="medium" textAlign="center" fontSize="sm">
              {tab.Title}
            </Text>
          </Box>
        ))}
      </SimpleGrid>

      {/* Modal Popup */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="xl" motionPreset="scale">
        <ModalOverlay backdropFilter="blur(8px)" />
        <ModalContent borderRadius="lg" p={2}>
          <ModalHeader fontSize="lg" fontWeight="bold">
            {selectedTab?.Title}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={3} align="start">
              {selectedTab?.children}
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Navbar */}
      <Box mt="50px">
        <Navbar />
      </Box>
    </div>
  );
}

export default Resources;
